import { render, staticRenderFns } from "./VersionModalInviteTeam.vue?vue&type=template&id=2f323cfe&scoped=true"
import script from "./VersionModalInviteTeam.vue?vue&type=script&lang=js"
export * from "./VersionModalInviteTeam.vue?vue&type=script&lang=js"
import style0 from "./VersionModalInviteTeam.vue?vue&type=style&index=0&id=2f323cfe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f323cfe",
  null
  
)

export default component.exports